module.exports = __webpack_public_path__ + "prod/1.42.2/img/fenxiao-one.c55e3a7e.png";